import {
  resultFromEither
} from "./chunk-CDKS5KAL.js";

// src/codecs/index.ts
export * from "io-ts";

// src/codecs/from-refinement.ts
import * as t from "io-ts";
function fromRefinement(name, is) {
  return new t.Type(
    name,
    is,
    (input, context) => is(input) ? t.success(input) : t.failure(input, context),
    t.identity
  );
}

// src/codecs/date.ts
var DateCodec = fromRefinement(
  "Date",
  (input) => input instanceof Date
);

// src/codecs/email.ts
import * as t2 from "io-ts";

// src/codecs/with-mapper.ts
import { map } from "fp-ts/lib/Either";
function clone(codec) {
  const copy = Object.create(Object.getPrototypeOf(codec));
  Object.assign(copy, codec);
  return copy;
}
function withMapper(codec, mapper, name = codec.name) {
  const copy = clone(codec);
  copy.decode = (i) => map(mapper)(codec.decode(i));
  copy.name = name;
  return copy;
}

// src/codecs/email.ts
var EmailAddress = withMapper(
  t2.brand(
    t2.string,
    (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v),
    "EmailAddress"
  ),
  (email) => email.trim().toLowerCase()
);

// src/codecs/entity.ts
import * as t3 from "io-ts";
var Id = t3.brand(t3.string, (s) => s.length > 0, "Id");
var Entity = t3.type({
  /**
   * Unique identifier of the entity.
   */
  id: Id
});

// src/codecs/from-enum.ts
function fromStringEnum(name, value) {
  return fromRefinement(
    name,
    (input) => Object.values(value).includes(input)
  );
}

// src/codecs/string.ts
import * as t4 from "io-ts";
var NonEmptyString = t4.brand(
  t4.string,
  (v) => v.trim().length > 0,
  "NonEmptyString"
);

// src/codecs/throw-on-fail.ts
import { PathReporter } from "io-ts/lib/PathReporter";
function throwOnFail(result) {
  const [errors, value] = resultFromEither(result);
  if (errors != null) throw new Error(PathReporter.report(result).join("\n"));
  return value;
}

// src/codecs/url.ts
import * as t5 from "io-ts";
var URL = globalThis["URL"];
var Url = t5.brand(
  t5.string,
  (v) => {
    try {
      new URL(v);
      return true;
    } catch (e) {
      return false;
    }
  },
  "Url"
);

// src/codecs/token.ts
import * as t6 from "io-ts";
var Token = t6.brand(
  t6.string,
  (s) => s.length === TOKEN_LENGTH,
  "Token"
);
var TOKEN_LENGTH = 16;

// src/codecs/name.ts
import * as t7 from "io-ts";
var urlRegex = /(?:https?|ftp|mailto|file):\/\//i;
var Name = t7.brand(
  t7.string,
  (v) => !urlRegex.test(v),
  "Name"
);

// src/codecs/hex-color.ts
import * as t8 from "io-ts";
var HexColor = t8.brand(
  t8.string,
  (v) => /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i.test(v),
  "HexColor"
);

// src/codecs/ip-address.ts
import * as t9 from "io-ts";
import { isIP } from "is-ip";
var IpAddress = withMapper(
  t9.brand(t9.string, (v) => isIP(v), "IpAddress"),
  (ipAddress) => ipAddress.trim()
);

// src/codecs/geo-location.ts
import * as t10 from "io-ts";
var GeoLatitude = t10.brand(
  t10.number,
  // TODO: see location data in the db (getting issues for values outside of -90 to 90)
  (lat) => lat >= -180 && lat <= 180,
  "GeoLatitude"
);
var GeoLongitude = t10.brand(
  t10.number,
  (lng) => lng >= -180 && lng <= 180,
  "GeoLongitude"
);
var GeoLocation = t10.exact(
  t10.type({
    latitude: GeoLatitude,
    longitude: GeoLongitude
  })
);

// src/codecs/password.ts
import * as t11 from "io-ts";
var PasswordString = t11.brand(
  t11.string,
  (v) => v.trim().length >= MIN_PASSWORD_LENGTH,
  "PasswordString"
);
var MIN_PASSWORD_LENGTH = 6;

// src/codecs/week-days.ts
var WeekDays = /* @__PURE__ */ ((WeekDays2) => {
  WeekDays2["Sunday"] = "Sunday";
  WeekDays2["Monday"] = "Monday";
  WeekDays2["Tuesday"] = "Tuesday";
  WeekDays2["Wednesday"] = "Wednesday";
  WeekDays2["Thursday"] = "Thursday";
  WeekDays2["Friday"] = "Friday";
  WeekDays2["Saturday"] = "Saturday";
  return WeekDays2;
})(WeekDays || {});
var WeekDaysCodec = fromStringEnum("WeekDays", WeekDays);

export {
  fromRefinement,
  DateCodec,
  EmailAddress,
  Id,
  Entity,
  fromStringEnum,
  NonEmptyString,
  throwOnFail,
  Url,
  Token,
  TOKEN_LENGTH,
  Name,
  HexColor,
  IpAddress,
  GeoLatitude,
  GeoLongitude,
  GeoLocation,
  PasswordString,
  MIN_PASSWORD_LENGTH,
  WeekDays,
  WeekDaysCodec
};
